/** api-runner background task ids are UUIDs; agentic v2 task ids are Mongo ObjectIds. */
const RUNNER_TASK_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isRunnerBackgroundTaskId(taskId: string | null | undefined): boolean {
  if (!taskId) return false;
  return RUNNER_TASK_UUID_RE.test(taskId.trim());
}
